export default "__VITE_ASSET__CyRYTS0n__"